export default __webpack_public_path__ + "24ce76bfa29fcaccfed015f5915150a0.svg";